export const MAX_SHOWN_AFTER_TRUNCATION = 4;
export const MAX_BEFORE_TRUNCATION = 20;
